__turbopack_context__.v({
  "assistantIcon": "institutional-landing-showcase-module__qjbmsG__assistantIcon",
  "context": "institutional-landing-showcase-module__qjbmsG__context",
  "eyebrow": "institutional-landing-showcase-module__qjbmsG__eyebrow",
  "institutionIcon": "institutional-landing-showcase-module__qjbmsG__institutionIcon",
  "itemCheck": "institutional-landing-showcase-module__qjbmsG__itemCheck",
  "items": "institutional-landing-showcase-module__qjbmsG__items",
  "panel": "institutional-landing-showcase-module__qjbmsG__panel",
  "preview": "institutional-landing-showcase-module__qjbmsG__preview",
  "prompt": "institutional-landing-showcase-module__qjbmsG__prompt",
  "response": "institutional-landing-showcase-module__qjbmsG__response",
  "responseHeading": "institutional-landing-showcase-module__qjbmsG__responseHeading",
  "reveal": "institutional-landing-showcase-module__qjbmsG__reveal",
  "review": "institutional-landing-showcase-module__qjbmsG__review",
  "showcase": "institutional-landing-showcase-module__qjbmsG__showcase",
  "tab": "institutional-landing-showcase-module__qjbmsG__tab",
  "tabs": "institutional-landing-showcase-module__qjbmsG__tabs",
  "windowHeader": "institutional-landing-showcase-module__qjbmsG__windowHeader",
});
